<script>
	import { TIME, IS_FINISHED, IS_PLAYING, IS_STOPPED, IS_INTERFACE_VISIBLE, IS_LOADING } from '../stores.js';
	import { TEXT_LOADING } from '../config';
  import padStart from 'lodash/padStart';

  let isLoading;
  IS_LOADING.subscribe(v => {
    isLoading = v;
  });

  let time;
  TIME.subscribe(v => {
    var minutes = Math.floor((v) / 60);
    var seconds = Math.floor(v - (minutes * 60));
    time = `${padStart(minutes, 2, '0')}:${padStart(seconds, 2, '0')}`;
  });

  function toggle () {
    IS_FINISHED.update((d) => !d);
  }
</script>

<div class="page-status" on:click={toggle}>
	{ isLoading ? TEXT_LOADING : '' }
</div>